import React from 'react'
import Popup from '@SiteComponents/Popup'
import CancelSubscriptionForm from './CancelSubscriptionForm'
import CancelSubscriptionFormTrial from './CancelSubscriptionFormTrial'

import {
  ICancelSubscriptionPayload,
} from '@SiteModules/Subscription/types'

import './CancelSubscriptionPopup.scss'

interface CancelSubscriptionPopupProps {
  closePopup(): void
  cancelSubscription(payload: ICancelSubscriptionPayload): void
  readonly availableTotalCredits: number
  readonly plan: string
  readonly subscriptionIsTrialing: boolean
  readonly currentAccountId: number
}

const CancelSubscriptionPopup: React.FC<CancelSubscriptionPopupProps> = props => {
  return (
    <Popup
      className="CancelSubscriptionPopup"
      closePopup={props.closePopup}
    >
      {props.subscriptionIsTrialing ? (
        <CancelSubscriptionFormTrial
          cancelSubscription={props.cancelSubscription}
          closePopup={props.closePopup}
          currentAccountId={props.currentAccountId}
        />
      ) : (
        <CancelSubscriptionForm
          cancelSubscription={props.cancelSubscription}
          closePopup={props.closePopup}
          availableTotalCredits={props.availableTotalCredits}
          plan={props.plan}
          currentAccountId={props.currentAccountId}
        />
      )}
    </Popup>
  )
}

export default CancelSubscriptionPopup
